export const navigation = [
  {
    id: 'solutions',
    label: 'solutions',
  },
  {
    id: 'products',
    label: 'products',
  },
  {
    id: 'technologies',
    label: 'technologies',
  },
  {
    id: 'approach',
    label: 'approach',
  },
  {
    id: 'contact-us',
    label: 'contact us',
  },
];
